import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4577f98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_header" }, " 간편비번 분실 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body" }, [
  /*#__PURE__*/_createTextVNode(" 본인 확인을 위해"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 다음 정보를 입력해주세요 ")
], -1))
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 이름 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 전화번호 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 생년월일 ")
const _hoisted_8 = { class: "login_body" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 인증번호를 발송했습니다 ")
const _hoisted_11 = { class: "form-container" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 인증번호 6자리 ")
const _hoisted_13 = { class: "resend-container" }
const _hoisted_14 = { class: "timer" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 2,
  class: "error-message"
}
const _hoisted_17 = { class: "footer-btn-container" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_left_top_logo = _resolveComponent("left-top-logo")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_left_top_logo),
            _hoisted_2,
            (_ctx.step === 'identity')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_ion_item, { class: "form-item" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.form.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                          type: "text",
                          placeholder: "이름"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "form-item" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.form.phone,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phone) = $event)),
                          type: "tel",
                          placeholder: "01000000000"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "form-item" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.form.birthDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.birthDate) = $event)),
                          type: "date",
                          placeholder: "YYYY-MM-DD"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.step === 'sms')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.form.phone) + "로", 1),
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ion_item, { class: "form-item" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.smsCode,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.smsCode) = $event)),
                          type: "number",
                          maxlength: "6",
                          placeholder: "000000"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.timerText), 1),
                      _createElementVNode("button", {
                        class: "resend-btn",
                        disabled: _ctx.resendDisabled,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendSms && _ctx.sendSms(...args)))
                      }, " 재발송 ", 8, _hoisted_15)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { translucent: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_17, [
            (_ctx.step === 'identity')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "block_btn",
                  disabled: !_ctx.isFormValid,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleIdentitySubmit && _ctx.handleIdentitySubmit(...args)))
                }, " 인증번호 발송 ", 8, _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.step === 'sms')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "block_btn",
                  disabled: !_ctx.smsCode || _ctx.smsCode.length < 6,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSmsVerify && _ctx.handleSmsVerify(...args)))
                }, " 확인 ", 8, _hoisted_19))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}